import { useMemo } from 'react';

export const detectPlatform = (userAgent = globalThis.navigator?.userAgent ?? ''): 'mac' | 'other' => {
    return userAgent.includes('Mac') ? 'mac' : 'other';
};

export const useKeyboardShortcutDisplay = (key: string): string => {
    return useMemo(() => {
        const platform = detectPlatform();

        return platform === 'mac' ? `⌘${key}` : `Ctrl+${key}`;
    }, [key]);
};
